import { animate, stagger } from 'framer-motion';
import { useEffect } from 'react';
import PageHeader from '../CommonComps/Titles/PageHeader';
import Notification from './Notification';

const ShowAllNotifications = () => {
  // animating notification cards one by one here
  useEffect(() => {
    animate(
      '.notification',
      { opacity: 1, y: 0 },
      { duration: 0.5, delay: stagger(0.1) }
    );
  }, []);

  // rendering show all notification component here
  return (
    <section>
      <PageHeader headerText='All Notifications' />

      <div className='space-y-3'>
        <Notification />
        <Notification />
        <Notification />
        <Notification />
        <Notification />
        <Notification />
        <Notification />
      </div>
    </section>
  );
};

export default ShowAllNotifications;
